import {
  createRouter,
  createWebHistory,
  isNavigationFailure,
} from "vue-router";
import { useAuthStore } from "@/stores";
import routes from "./routes";
import { requireCoach } from "./routeMiddleware";
import { routerLogger } from "@/utils/consoleLoggers";

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach((to, from, failure) => {
  routerLogger("Navigation to:", to.path)
  if (isNavigationFailure(failure)) {
    routerLogger("Navigation FAILED:", failure);
  }
});

router.beforeEach(async (to, from, next) => {
  routerLogger("Navigation from:", from.path)

  const authStore = useAuthStore();

  function checkRoleAndContinue() {
    if (to.matched.some(record => record.meta.requireCoach)) {
      routerLogger("Checking For Coach Role");
      return requireCoach(to, from, next);
    }
    return next();
  }

  if (to.path === "/logout") {
    return authStore
      .logout()
      .then(() => next({ name: "Login", query: to.query }))
      .catch((error) => {
        console.log(error);
        next({ name: "Login", query: to.query });
      });
  }

  if (to.meta.public) {
    next();
    return;
  }

  if (authStore.isLoggedIn) {
    console.log("isLoggedIn, moving on.");
    return checkRoleAndContinue();
  }

  try {
    await authStore.restore();
    console.log("restored session, moving on.");
    return checkRoleAndContinue();
  } catch (err) {
    console.log("restore failed, redirecting to login", err);
    authStore.returnUrl = to.fullPath;
    return next({ name: "Login" });
  }
});

export default router;
